<template>
	<b-container fluid class="margin-top-header">
		<b-row>
			<b-col cols="12">
				<b-link class="text-macal" to="/autos/vende/cotizar">
					<b><font-awesome-icon :icon="['fal', 'chevron-left']" />VOLVER</b>
				</b-link>
			</b-col>
			<b-col>
				<b-row>
					<b-col>
						<h2 class="text-center mb-5">Agenda tu visita</h2>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12"  md="6" lg="4" :class='{"text-right": true }'>
						<multiselect class="mb-4" style="z-index: 10000;" v-model="branch_id" :options="branches" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Selecciona Sucursal" track-by="Id" label="Valor" @input="changeDate()">
							<template slot="noOptions">Debes seleccionar Sucursal primero.</template>
						</multiselect>
						<b-col v-if="calendar_get_dates_loading" cols="12" class="text-center mt-5 mb-5">
							<grid-loader :color="color"></grid-loader>
						</b-col>
						<datepicker class="w-100 mb-3" v-model="reservation.date" bootstrap-styling :disabled-dates="dateState.disabled" :highlighted="dateState.highlighted" :monday-first="true" :language="es" :inline="true"></datepicker>
						<!--
						<FunctionalCalendar v-model="calendarData" :isDatePicker="true"></FunctionalCalendar>
						-->
					</b-col>
					<b-col cols="12" md="6" lg="8">
						<div class="hours-list p-4" style="border: 1px solid #ccc;">
							<h5>{{hourTitle || "Selecciona una sucursal y fecha para ver los horarios disponibles"}}</h5>
							<b-col v-if="calendar_get_hours_loading" cols="12" class="text-center mt-5 mb-5">
								<grid-loader :color="color"></grid-loader>
							</b-col>
								<!--
							:class="{ active: auction.selected, 'shadow-sm p-0': true}" show v-for="(auction, index) in auctions" :key="index" :id="'auction-'+auction.id" :data-id="auction.id" :data-title="auction.title">
							<table @click="filterAuction"
							-->
							<h4 class="m-0 mt-3 px-2 col-6 col-md-4 col-lg-3 d-inline-block" v-for="(hour, index) in hours" :key="index" >
								<b-badge  :variant="(hour.selected ? 'macal' : 'light-grey')" :class="{ active: hour.selected, 'w-100 shadow-sm': true}" show  :id="'hour-'+hour.id" :data-title="hour.hour" @click="selectHour(hour)" >
									<b>{{hour.hour}}</b>
								</b-badge>
							</h4>
						</div>
					</b-col>
					<b-col cols="12" v-if="reservation.hour" class="text-right">
						<b-button size="lg" class=" mt-2 px-5" variant="outline-macal" @click="confirmReservation">Continuar</b-button>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import Multiselect from 'vue-multiselect';
	import Datepicker from 'vuejs-datepicker';
	import {es} from 'vuejs-datepicker/dist/locale';
	import { required, minLength, maxLength, email } from "vuelidate/lib/validators";

export default {
	name: 'v-sell-modal',
	components: {
		Multiselect,
		Datepicker,
	},
	props: {
		price: String,
		data: {default: null},
		car: {default: null},
		reservation: {default: null},
		branches: {default: null},
	},
	data (){
		return{
			send_loading: false,
			calendar_get_dates_loading: false,
			phone_reservation_loading: false,
			calendar_reservation_loading: false,
			calendar_get_hours_loading: false,
			showUserData: false,
			showConfirmData: false,
			showSuccess: false,
			showCallQuote: false,
			es: es,
			calendarData: {},
			setSchedule: false,
			captcha: {
				sitekey: process.env.VUE_APP_CAPTCHA_KEY,
				valid: false,
				error: false,
			},
            color: "#E4610C",
			plateData: {
				brand: null,
				year: null,
				model: null
			},
			loading: {
				brand: false,
				year: false,
				model: false,
				version: false,
			},
			errors: '',
			hour: "",
			date: "",
			brands: [],
			years: [],
			models: [],
			versions: [],
			kms: [
				{ value: 5000, text: "5.000" },
				{ value: 10000, text: "10.000" },
				{ value: 20000, text: "20.000" },
				{ value: 30000, text: "30.000" },
				{ value: 40000, text: "40.000" },
				{ value: 50000, text: "50.000" },
				{ value: 60000, text: "60.000" },
				{ value: 70000, text: "70.000" },
				{ value: 80000, text: "80.000" },
				{ value: 90000, text: "90.000" },
				{ value: 100000, text: "100.000" },
				{ value: 150000, text: "150.000" },
				{ value: 200000, text: "200.000" },
			],
			dateState: {
				disabled: {
					to: new Date,
					from: new Date,
				},
				highlighted: {}
			},
			branch_id: null,
			dateTitle: null,
			hourTitle: null,
			hours: [],
			phone_reservation:{
				name: "",
				lastname: ""
			},
			submited: false,
		}
	},
	validations: {
		car:{
			brand: { required },
			year: { required },
			model: { required },
			version: { required },
			km: { required },
			terms: { required },
		},
		reservation: {
			phone: {required, minLength: minLength(12), maxLength: maxLength(12)},
			email: {required, email},
		},
		phone_reservation: {
			name: {required, minLength: minLength(3)},
			lastname: {required, minLength: minLength(3)},
		}
	},
	computed: {},
	mounted() {
		this.$moment.locale('es');
		this.amount= this.price;
	},
	beforeMount() {
		this.hasReservation();
	},
	methods: {
		hasReservation(){
			if(this.reservation == null){
				this.$router.push({ name: 'vehicles-sell-quote' });
			}
		},
		confirmReservation(){
			const cur = this;
			cur.$router.push({ name: 'vehicles-sell-quote-schedule-response', params: {reservation: cur.reservation, data: cur.data, car: cur.car, branch_id: cur.branch_id}});
		},
		changeDate(){
			const cur = this;
			this.dateState = {disabled: { to: new Date,	from: new Date,	},	highlighted: {}	};
			this.reservation.date = null;
			this.calendar_get_dates_loading = true;
			this.axios.get("sells/get_dates", {params: { date: this.reservation.date, branch_id: this.branch_id.Id}}).then(result => {
				cur.hours = []
				cur.reservation.hour = null;
				cur.hourTitle = null;
				cur.dates = result.data;
				cur.dateTitle = result.data.message;
				this.calendar_get_dates_loading = false;
				let parsedDates = []
				for (let unavaliable_date of cur.dates.unavaliable_dates) {
					parsedDates.push(new Date(unavaliable_date));
				}
				cur.dateState.disabled = {
					to: new Date(cur.dates.min), // Disable all dates up to specific date
					from: new Date(cur.dates.max), // Disable all dates after specific date
					dates: parsedDates
				}
				cur.dateState.highlighted = {
					to: new Date(cur.dates.max), // Highlight all dates up to specific date
					from: new Date(cur.dates.min), // Highlight all dates after specific date
					includeDisabled: false // Highlight disabled
				}
			})
		},
		selectHour(hour){
			const cur = this;
			this.hours.forEach(function(el, index){
				cur.hours[index].selected = false;
			});
			hour.selected = true;
			this.reservation.hour = hour.hour_with_secs;
			this.reservation.inspector_id = hour.inspector_id;
			//document.querySelector(".hours-list").querySelector(".active").classList.remove("active");
			//document.getElementById("hour-"+hour.id).closest(".alert").classList.add("active");
			//this.auction = { name: event.target.closest(".alert").dataset.title, code: "auction", value: event.target.closest(".alert").dataset.id }
		}
	},
	watch: {
		'reservation.date': {
			handler: function() {
				const cur = this;
				cur.hours = [];
				cur.reservation.hour = null;
				if(this.branch_id !== null){
					cur.reservation.branch_id = this.branch_id.Id;
					cur.hourTitle = "";
					if(this.reservation.date !== null){
						this.calendar_get_hours_loading = true
						this.axios.get("sells/get_hours", {params: { date: this.reservation.date, branch_id: this.reservation.branch_id}}).then(result => {
							this.calendar_get_hours_loading = false
							cur.hours = result.data.hours;
							cur.hourTitle = result.data.message;
						})
					}
				}
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	#modal-sell___BV_modal_outer_{
		z-index: 1060 !important;
	}
	#modal-sell .multiselect-sm {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
	}
	#modal-sell .multiselect-sm .multiselect__tags {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
		padding: 0.25rem 0.5rem !important;
	}
	#modal-sell .multiselect-sm .multiselect__select {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		padding: 0.25rem 0.5rem !important;
	}
	.w-100 .vdp-datepicker__calendar{
		width: 100%;
	}
	.captcha-element>div>div{
		margin-left: auto;
		margin-right: auto;
	}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
